// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e5bbd91c","427":"bc85dcce"}[chunkId] + ".chunk.js";
};